import { FC } from 'react';
import { ModalFooter } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';

interface ScheduledMessagesRescheduleModalFooterProps {
  closeModal: () => void;
}

const ScheduledMessagesRescheduleModalFooter: FC<
  ScheduledMessagesRescheduleModalFooterProps
> = ({ closeModal }) => {
  const { t } = useTranslation();
  const { isSubmitting } = useFormState();

  return (
    <ModalFooter>
      <ModalFormCancelButton closeOnClick={false} onClick={closeModal} />
      <ModalFormSubmitButton>
        {isSubmitting
          ? t('common.saving')
          : t('pageAutomations.scheduledMessages.modalReschedule.title')}
      </ModalFormSubmitButton>
    </ModalFooter>
  );
};

export default ScheduledMessagesRescheduleModalFooter;
